<template>
    <b-row>
        <b-col cols="12">
            <TitleComponent title="1. Selecciona tu asiento" subtitle="Si lo deseas, también puedes escoger varios asientos a la vez"/>
        </b-col>
        <b-col cols="12">
            <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo" :tipo_recinto="zona.tipo_recinto"/>
        </b-col>
        <template v-if="filas">
            <b-col cols="12">
                <div class="container-butacas-wrapper">
                    <div :class="'container-butacas text-align-' + zona.print_align">
                        <span v-for="(butacas, fila) in filas" :key="fila">
                            <span class="fila">{{ fila }}</span>
                            <AsientoComponent v-for="(asiento, index) in butacas" :asiento="asiento" :fila="fila" :key="index+'_2'" @toggle="() => toggleSeleccion(fila, asiento.asiento, asiento)" />
                            <br />
                        </span>
                    </div>
                </div>
            </b-col>
            <b-col sm="12" md="3" class="mb-4">
                <b-input-group>
                    <b-form-input 
                        v-model.number="numeroButacas" 
                        type="number" 
                        min="1" 
                        placeholder="Número de butacas a seleccionar"
                    />
                    <b-input-group-append>
                        <b-button variant="primary" @click="seleccionarCantidad">
                            Seleccionar cantidad
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col sm="12" md="3" class="mb-3 mt-0 mt-md-2 pt-0 pt-md-1 ml-1 ml-md-0">
                <b-button variant="primary" @click="seleccionarTodos">
                    Seleccionar todos los asientos disponibles
                </b-button>
            </b-col>
        </template>
        <template v-else>
            <LoaderComponent/>
        </template>
    </b-row>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import TerrenoJuegoComponent from '../../../common/Asientos/TerrenoJuegoComponent.vue';
    import AsientoComponent from "./AsientoComponent";

    export default {
        props: {
            zona: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                filas: null,
                numeroButacas: null
            }
        },
        methods: {
            getZona(id) {
                const params = {
                    filters: {
                        zona_id: id,
                        conf: true,
                        info: true,
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id
                    },
                };

                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.filas = res.data.configuracion_asientos;
                });
            },
            toggleSeleccion(fila, asiento, status) {
                if (status.info && status.info.tipo === "BLOQUEADO" && status.info.reserva_id === null) {
                    if (status.seleccionado) {
                        status.seleccionado = false;
                        this.$emit('deleteSeat', fila, asiento);
                    } else {
                        status.seleccionado = true;
                        this.$emit('addSeat', fila, asiento, status);
                    }
                } else {
                    this.$toast.error('Asiento no disponible.');
                }
            },
            seleccionarTodos() {
                const asientosDisponibles = Object.entries(this.filas)
                    .flatMap(([fila, butacas]) =>
                        butacas.filter(asiento => 
                            asiento.info &&
                            asiento.info.tipo === "BLOQUEADO" &&
                            asiento.info.reserva_id === null
                        ).map(asiento => ({ fila, asiento }))
                    );

                const todosSeleccionados = asientosDisponibles.every(item => item.asiento.seleccionado);
                asientosDisponibles.forEach(item => {
                    item.asiento.seleccionado = !todosSeleccionados;
                    this.$emit(
                        todosSeleccionados ? 'deleteSeat' : 'addSeat',
                        item.fila,
                        item.asiento.asiento,
                        item.asiento
                    );
                });
            },
            seleccionarCantidad() {
                const cantidad = this.numeroButacas;
                if (!cantidad || cantidad <= 0)
                    return this.$toast.error('Ingrese un número válido de butacas.');

                const asientos = Object.entries(this.filas).flatMap(([fila, butacas]) =>
                    butacas.filter(a => a.info && a.info.tipo === "BLOQUEADO" && a.info.reserva_id === null)
                        .map(a => ({ fila, a }))
                );
                const seleccionados = asientos.filter(item => item.a.seleccionado);
                const diff = cantidad - seleccionados.length;

                if (diff === 0) {
                    seleccionados.forEach(item => {
                        item.a.seleccionado = false;
                        this.$emit('deleteSeat', item.fila, item.a.asiento);
                    });
                } else if (diff > 0) {
                    asientos.filter(item => !item.a.seleccionado)
                        .slice(0, diff)
                        .forEach(item => {
                            item.a.seleccionado = true;
                            this.$emit('addSeat', item.fila, item.a.asiento, item.a);
                        });
                } else {
                    seleccionados.slice(0, -diff)
                        .forEach(item => {
                            item.a.seleccionado = false;
                            this.$emit('deleteSeat', item.fila, item.a.asiento);
                        });
                }
            }
        },
        created() {
            this.getZona(this.zona.id);
        },
        components: {
            TitleComponent, TerrenoJuegoComponent, AsientoComponent
        }
    }
</script>